module.exports = __webpack_public_path__ + "img/intro03.de40633b.png";